<div class="container" style="max-width:1024px!important">
  <div class="row">
    <div class="col col-12">
      <app-menu style="width:inherit;max-width:inherit;background-color:#ffffff;"></app-menu>
    </div>
  </div>
  <div class="row">
    <div class="col col-12">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="menu-padding">

  </div>
  
</div>

